import mAxios from './m-axios'
import { newOrg, Org } from './org'
export interface User {
  index?: number
  user_id: string
  name: string // 真实名称
  nickname: string // 昵称
  username: string // 登录名
  phone: string
  image: string
  org: Org
  role?: Role
  key?: number
  expiry?: string
  email: string
  type: string
  action?: string
}

interface EditPasswordFrom {
  user_id: string
  phone?: string
  captcha?: string
  old_password?: string
  new_password: string
}

export interface MasterRole {
  role_id: string
  activated: number
}
export interface Role {
  users?: RoleUser[]
  modules?: RoleModule[]
  key?: string
}

export interface RoleModule {
  module_id: number
  expiry?: Date
}

export interface RoleUser {
  key?: number
  module_id: number
  // 年限
  years: number
  // 总人数
  users: number
  // 激活人数
  activated: number
  //  剩余人数
  available: number
}

export const newUser = (): User => ({
  user_id: '',
  name: '',
  phone: '',
  nickname: '',
  username: '',
  image: '',
  org: newOrg(),
  email: '',
  type: '',
})

export const editUser = (user: User) => {
  return mAxios({
    method: 'put',
    url: '/api/user',
    data: user,
  }).then(res => res.data)
}

export const addUser = (school: User, teacher: User) => {
  return mAxios({
    method: 'post',
    url: '/api/user/teacher',
    data: {
      school_user: school,
      teacher: teacher,
    },
  }).then(res => res.data)
}

export const editPassword = (form: EditPasswordFrom) => {
  return mAxios({
    method: 'put',
    url: '/api/user/password',
    data: form,
  }).then(res => res.data)
}

export const getUser = () => {
  return mAxios({
    method: 'get',
    url: '/api/user/info',
  }).then(res => res.data)
}
